import { BE_FORM_DATE_FORMAT } from "@farzoom/common-ui-components";
import moment from "moment";

type DateType = string | Date | null | undefined;

export const ISSUE_DATE_WARNING_MESSAGE = "Внимание, срок действия паспорта истек";

export function validatePassportIssueDate(birthDate: DateType, issueDate: DateType) {
  if (!birthDate || !issueDate) {
    return true;
  }

  const issue = moment(issueDate, BE_FORM_DATE_FORMAT);
  const birth = moment(birthDate, BE_FORM_DATE_FORMAT);
  const today = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const age = today.diff(birth, "years");

  const ageAtIssue = issue.diff(birth, "years");
  const age20 = birth.clone().add(20, "years");
  const age20With90Days = age20.clone().add(90, "days");
  const age45 = birth.clone().add(45, "years");
  const age45With90Days = age45.clone().add(90, "days");

  if (ageAtIssue < 14 || issue.isAfter(today)) {
    return false;
  }

  if (age >= 14 && age < 20) {
    return ageAtIssue >= 14 && ageAtIssue < 20;
  }

  if (age >= 20 && age < 45) {
    if (today.isSameOrBefore(age20With90Days)) {
      return issue.isSameOrBefore(age20With90Days);
    } else {
      return issue.isSameOrAfter(age20);
    }
  }

  if (age >= 45) {
    if (today.isSameOrBefore(age45With90Days)) {
      return issue.isSameOrBefore(age45With90Days);
    } else {
      return issue.isSameOrAfter(age45);
    }
  }

  return false;
}
